import React, { useState, useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '@/lib/api'

export const ConfirmDeleteAccount: React.FC = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setStatus('error')
      setMessage(t('deleteConfirm.invalid'))
      return
    }

    api
      .get(`/auth/confirm-delete?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus('success')
        setMessage(res.data.message || t('deleteConfirm.success'))
      })
      .catch((err) => {
        setStatus('error')
        setMessage(err.response?.data?.error || t('deleteConfirm.error'))
      })
  }, [searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0f] p-4">
      <div className="w-full max-w-md bg-[#12121a] border border-white/10 rounded-xl p-8 text-center">
        {status === 'loading' && (
          <div className="flex flex-col items-center gap-4">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#00d4aa]" />
            <p className="text-gray-300">{t('deleteConfirm.loading')}</p>
          </div>
        )}

        {status === 'success' && (
          <>
            <h1 className="text-2xl font-bold text-red-400 mb-4">{t('deleteConfirm.title')}</h1>
            <p className="text-gray-300 mb-6">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="px-6 py-2 bg-[#006cd4] hover:bg-[#0052a3] text-white rounded-lg transition-colors"
            >
              {t('deleteConfirm.goHome')}
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <h1 className="text-2xl font-bold text-red-400 mb-4">{t('deleteConfirm.errorTitle')}</h1>
            <p className="text-gray-300 mb-6">{message}</p>
            <button
              onClick={() => navigate('/login')}
              className="px-6 py-2 bg-[#006cd4] hover:bg-[#0052a3] text-white rounded-lg transition-colors"
            >
              {t('deleteConfirm.goLogin')}
            </button>
          </>
        )}
      </div>
    </div>
  )
}
